import { getTestId } from '@airtel/air-design-system';
var linkListItemWidgetProps = {
  avatarIcon: 'TransactionHistoryIcon',
  title: 'xstream fibre - 012447381916_dsl',
  heading: 'Router Not Working',
  subHeading: 'Request ID: 31-23454323234',
  metaInfoText: 'Resolution by: 1 Jan 2023 at 15:45',
  onPress: {
    id: 'linkList'
  },
  onUserAction: data => {
    console.log(data);
  }
};
var priceBreakUpWidgetProps = {
  title: 'more information',
  list: [{
    leftDetails: {
      text: 'Order ID'
    },
    rightDetails: {
      text: '₹599.00'
    }
  }, {
    leftDetails: {
      text: 'Order Type'
    },
    rightDetails: {
      text: '₹599.00'
    }
  }, {
    leftDetails: {
      text: 'Order Sub Type'
    },
    rightDetails: {
      text: '₹599.00'
    }
  }, {
    leftDetails: {
      text: 'Connection Type'
    },
    rightDetails: {
      text: '₹599.00'
    }
  }, {
    leftDetails: {
      text: 'RTN'
    },
    rightDetails: {
      text: '₹599.00'
    }
  }, {
    leftDetails: {
      text: 'Airtel Black ID'
    },
    rightDetails: {
      text: '₹599.00'
    }
  }, {
    leftDetails: {
      text: 'Source'
    },
    rightDetails: {
      text: '₹599.00'
    }
  }, {
    leftDetails: {
      text: 'Created By'
    },
    rightDetails: {
      text: '₹599.00'
    }
  }, {
    leftDetails: {
      text: 'Created Date'
    },
    rightDetails: {
      text: '₹599.00'
    }
  }],
  onPress: {
    id: 'priceBreakup'
  },
  onUserAction: data => {
    console.log(data);
  }
};
var trackOrderStepperWidgetProps = {
  direction: 'vertical',
  size: 'lg',
  steps: [{
    heading: 'completed step',
    subHeading: '1 Jan 2023 at 12:45 pm',
    state: 'success'
  }, {
    heading: 'active step',
    subHeading: '1 Jan 2023 at 12:45 pm',
    state: 'default',
    stepNumber: '2'
  }, {
    heading: 'future step',
    state: 'disabled',
    stepNumber: '4'
  }, {
    heading: 'future step',
    state: 'disabled',
    stepNumber: '5'
  }],
  onPress: {
    id: 'stepper'
  },
  onUserAction: data => {
    console.log(data);
  }
};
export var defaultProps = Object.assign({
  linkListItemWidgetProps: linkListItemWidgetProps,
  priceBreakUpWidgetProps: priceBreakUpWidgetProps,
  trackOrderStepperWidgetProps: trackOrderStepperWidgetProps,
  gridColLinkListProps: {
    noTopGutter: true
  }
}, getTestId('TrackingDetailedWidgetContainer'));